import { cn } from "@/lib/utils";

/** A friendly, drawn apple (no emoji) — warm red with a teal leaf. */
export function Apple({ size = 64, className }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} aria-hidden focusable="false">
      <defs>
        <radialGradient id="appleBody" cx="38%" cy="30%" r="75%">
          <stop offset="0%" stopColor="#FF8A8A" />
          <stop offset="55%" stopColor="#F0463C" />
          <stop offset="100%" stopColor="#CC2E2E" />
        </radialGradient>
      </defs>
      <path d="M50 26 C53 16 59 12 66 12" stroke="#8B5A2B" strokeWidth="5" strokeLinecap="round" fill="none" />
      <path d="M53 23 C63 12 80 13 82 24 C71 33 57 31 53 23Z" className="fill-teal" />
      <path
        d="M50 30 C40 19 17 23 15 45 C13 66 28 88 41 90 C47 91 48 86 50 86 C52 86 53 91 59 90 C72 88 87 66 85 45 C83 23 60 19 50 30Z"
        fill="url(#appleBody)"
      />
      <ellipse cx="35" cy="46" rx="8" ry="13" fill="#FFFFFF" opacity="0.35" />
    </svg>
  );
}

export default Apple;
